import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { IVideoWidget, VideoWidgetType } from "apiConsumers/newsApiConsumer/models/INewsArticle";
import YouTube from "react-youtube";
import calculateAspectRatioPaddingTopPercentage from "utils/calculateAspectRatioPaddingTopPercentage";

const useStyles = makeStyles((theme: Theme) => {
    const youtubeAspectRatioPercentage = calculateAspectRatioPaddingTopPercentage({
        height: 9,
        width: 16,
    });

    return createStyles({
        root: {
            position: "relative",
            paddingBottom: youtubeAspectRatioPercentage,
            marginBottom: theme.spacing(1),
        },
        videoContainer: {
            "& iframe": {
                width: "100%",
                height: "100%",
                position: "absolute",
            },
        },
    });
});

interface IProps {
    video?: IVideoWidget;
}

export default function YoutubeVideoWidget(props: IProps) {
    const { video } = props;

    const classes = useStyles();

    if (typeof video === "undefined") return null;

    const { options, type: videoType, url } = video;

    if (typeof url === "undefined") return null;

    const { controls, fullscreen } = options;

    return (
        <div className={classes.root}>
            <div className={classes.videoContainer}>
                <YouTube
                    videoId={getVideoId(url, videoType)}
                    opts={{
                        playerVars: {
                            // https://developers.google.com/youtube/player_parameters
                            controls: controls ? 1 : 0,
                            fs: fullscreen ? 1 : 0,
                            list: videoType === "playlist" ? getListId(url) : undefined,
                            listType: videoType === "playlist" ? "playlist" : undefined,
                        },
                    }}
                />
            </div>
        </div>
    );
}

function getListId(videoUrl: string) {
    const listUrlTerm = "&list=";

    let param_l = videoUrl.indexOf(listUrlTerm);

    if (param_l <= -1) {
        return undefined;
    }

    return videoUrl.substring(param_l + listUrlTerm.length, videoUrl.length);
}

function getVideoId(videoUrl: string, videoType?: VideoWidgetType) {
    let param_v = videoUrl.indexOf("v=");

    if (param_v > -1) {
        if (videoType && videoType !== "single_video") {
            let param_l = videoUrl.indexOf("&list=");

            return videoUrl.substring(param_v + 2, param_l);
        }
        return videoUrl.substring(param_v + 2, videoUrl.length);
    }

    let param_embed = videoUrl.indexOf("/embed/");

    if (param_embed > -1) {
        return videoUrl.substring(param_embed + 7, videoUrl.length);
    }

    let param_be = videoUrl.indexOf("youtu.be/");

    if (param_be > -1) {
        return videoUrl.substring(param_be + 9, videoUrl.length);
    }
}
